<template>
  <div class="language-switch">
    <span class="label">{{ currentCopy.label }}</span>
    <div class="buttons">
      <el-button
        v-for="option in languageOptions"
        :key="option.key"
        size="small"
        round
        class="button"
        :type="language === option.key ? 'primary' : 'default'"
        @click="setLanguage(option.key)"
      >
        {{ option.label }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { languageOptions, languageState, setLanguage } from '@/i18n'

const CONTENT = {
  en: { label: 'Language' },
  zh: { label: '语言' },
}

export default {
  name: 'LanguageSwitch',
  data() {
    return {
      languageOptions,
      languageState,
    }
  },
  computed: {
    language() {
      return this.languageState.value
    },
    currentCopy() {
      return CONTENT[this.language] || CONTENT.en
    },
  },
  methods: {
    setLanguage,
  },
}
</script>

<style scoped>
.language-switch {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid rgba(210, 222, 237, 0.95);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(10px);
}

.label {
  font-size: 14px;
  font-weight: 700;
  color: #3a4b63;
}

.buttons {
  display: flex;
  gap: 8px;
}

.button {
  min-width: 84px;
}

@media (max-width: 768px) {
  .language-switch {
    padding: 8px 10px;
    gap: 8px;
  }

  .label {
    display: none;
  }

  .button {
    min-width: 72px;
  }
}
</style>
